import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ChatMagnifierIcon = (
  props: SvgIconProps & { custom?: string },
) => (
  <SvgIcon
    width="21"
    height="20"
    viewBox="0 0 21 20"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M18.2301 16.4605L14.5547 12.7852C15.4396 11.6072 15.9173 10.1733 15.9156 8.7C15.9156 4.93672 12.8539 1.875 9.09063 1.875C5.32734 1.875 2.26563 4.93672 2.26563 8.7C2.26563 12.4633 5.32734 15.525 9.09063 15.525C10.5639 15.5266 11.9978 15.049 13.1758 14.1641L16.8512 17.8395C17.0372 18.0058 17.2799 18.0945 17.5293 18.0876C17.7788 18.0806 18.0161 17.9784 18.1925 17.8019C18.369 17.6255 18.4712 17.3881 18.4782 17.1387C18.4852 16.8893 18.3964 16.6466 18.2301 16.4605ZM4.21563 8.7C4.21563 7.73582 4.50154 6.79329 5.03721 5.9916C5.57288 5.18991 6.33425 4.56506 7.22504 4.19609C8.11583 3.82711 9.09603 3.73057 10.0417 3.91867C10.9873 4.10678 11.856 4.57107 12.5378 5.25285C13.2196 5.93464 13.6839 6.80328 13.872 7.74894C14.0601 8.69459 13.9635 9.67479 13.5945 10.5656C13.2256 11.4564 12.6007 12.2177 11.799 12.7534C10.9973 13.2891 10.0548 13.575 9.09063 13.575C7.79817 13.5735 6.5591 13.0593 5.64519 12.1454C4.73129 11.2315 4.21718 9.99246 4.21563 8.7Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SvgIcon>
);
